import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import Moment from 'moment';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, change } from 'redux-form';
import swal from 'sweetalert2';
import { deleteAbsence } from 'actions/absence';
import { addError } from 'actions';
import DatePickerFromTo from './Partials/DatePickerFromTo';
import { Button, Checkbox, Radio, translate, getActiveLanguage } from '@haldor/ui';
var ReportAbsenceForm = /*#__PURE__*/function (_Component) {
  function ReportAbsenceForm(props) {
    var _this;
    _classCallCheck(this, ReportAbsenceForm);
    _this = _callSuper(this, ReportAbsenceForm, [props]);
    _defineProperty(_this, "componentDidMount", function () {
      if (_this.props.user != null) {
        _this.setState({
          loading: true
        });
      }
      if (_this.props.absence != null) {
        _this.selectAbsence(_this.props.absence);
      }
    });
    _defineProperty(_this, "onTimeChange", function (time) {
      if (_this.props.entireDay == 'yes') {
        _this.setState({
          timeStart: time.start.set({
            'minute': 0,
            'hour': 0
          }).format(),
          timeEnd: time.end.set({
            'minute': 59,
            'hour': 23
          }).format()
        });
      } else {
        _this.setState({
          timeStart: time.start.format(),
          timeEnd: time.end.set({
            'minute': time.end.minute(),
            'hour': time.end.hour()
          }).format()
        });
      }
    });
    _defineProperty(_this, "onCancel", function (event) {
      event.preventDefault();
      if (_this.props.onAbort) {
        _this.props.onAbort();
      }
    });
    _defineProperty(_this, "onEntireDay", function () {
      var start = Moment(_this.state.timeStart);
      var end = Moment(_this.state.timeEnd);
      start = start.set(_defineProperty(_defineProperty({
        'minute': 0,
        'hour': 0
      }, "minute", 0), 'second', 0));
      end = end.set(_defineProperty(_defineProperty({
        'minute': 59,
        'hour': 23
      }, "minute", 59), 'second', 0));
      _this.setState({
        timeStart: start,
        timeEnd: end
      });
    });
    _defineProperty(_this, "onPartOfDay", function () {
      _this.setState({
        timeStart: Moment(_this.state.timeStart).format(),
        timeEnd: Moment(_this.state.timeEnd).format()
      });
    });
    _defineProperty(_this, "onDelete", function (event) {
      event.preventDefault();
      if (_this.props.absence != null) {
        var _this$props$absence = _this.props.absence,
          startTime = _this$props$absence.startTime,
          id = _this$props$absence.id,
          reported = _this$props$absence.reported;
        var _translate = _this.props.translate;
        var disableDeletion = Moment.utc(startTime).local().unix() < Moment().unix() && Moment().diff(Moment.utc(reported).local(), 'minutes') > 15;

        // Check that the absence object sent is after the current date
        if (!disableDeletion) {
          swal({
            title: _translate('Are you sure?'),
            text: _translate('Absence will be removed permanently'),
            showCancelButton: true,
            cancelButtonText: _translate('No, cancel'),
            confirmButtonText: _translate('Yes')
          }).then(function (result) {
            if (result.value != null) {
              _this.props.deleteAbsence(id).then(function () {
                if (_this.props.onAbort) {
                  _this.props.onAbort();
                }
              });
            }
          });
        }
      }
    });
    _defineProperty(_this, "submit", function (values) {
      return new Promise(function (resolve, reject) {
        values.startTime = Moment.utc(_this.state.timeStart).format();
        values.endTime = Moment.utc(_this.state.timeEnd).format();
        values.userId = _this.props.user;
        values.period = _this.props.entireDay == 'yes';
        if (_this.state.id != null) {
          values.id = _this.state.id;
          var absenceObject = _this.props.absences.find(function (absence) {
            return values.id == absence.id;
          });
          if (absenceObject != null) {
            absenceObject.startTime = _this.state.timeStart;
            absenceObject.endTime = _this.state.timeEnd;
          }
        }
        if (_this.props.onSubmit) {
          _this.props.onSubmit(values).then(function () {
            resolve(1);
            if (values.id == null) {
              _this.setState({
                loading: true,
                submitResult: _this.props.submitResult
              });
            }
            _this.setState({});
          })["catch"](function () {
            _this.props.addError(_this.props.translate('Lost connection with the server, please try again'), 'error');
            _this.setState({
              loading: false
            });
            reject(0);
          });
        } else {
          resolve(1);
        }
      });
    });
    _defineProperty(_this, "selectAbsence", function (absence) {
      if (_this.state.id == absence.id) {
        _this.setState({
          id: null,
          timeStart: Moment().format(),
          timeEnd: Moment().format()
        });
        return true;
      }
      var start = Moment.utc(absence.startTime).local();
      var end = Moment.utc(absence.endTime).local();
      if (absence.period) {
        _this.props.dispatch(change(FORM_NAME, 'entireDay', 'yes'));
      } else {
        _this.props.dispatch(change(FORM_NAME, 'entireDay', 'no'));
      }
      _this.setState({
        id: absence.id,
        timeStart: start.format(),
        timeEnd: end.format()
      });
    });
    _defineProperty(_this, "onDatesValidate", function (valid) {
      _this.setState({
        datesInvalid: !valid
      });
    });
    _defineProperty(_this, "validatePeriod", function (value) {
      if (value == null || value == '') {
        return _this.props.translate('Required');
      }
      return undefined;
    });
    Moment.locale(getActiveLanguage());
    _this.state = {
      id: null,
      loading: true,
      timeStart: Moment(),
      timeEnd: Moment(),
      submitResult: null,
      datesInvalid: false
    };
    return _this;
  }
  _inherits(ReportAbsenceForm, _Component);
  return _createClass(ReportAbsenceForm, [{
    key: "render",
    value: function render() {
      var datesInvalid = this.state.datesInvalid;
      var _this$props = this.props,
        handleSubmit = _this$props.handleSubmit,
        submitting = _this$props.submitting,
        valid = _this$props.valid,
        translate = _this$props.translate,
        absence = _this$props.absence;
      var disableEditing = false;
      if (absence != null) {
        disableEditing = Moment.utc(absence.startTime).local().unix() < Moment().unix() && Moment().diff(Moment.utc(absence.reported).local(), 'minutes') > 15;
      }
      return /*#__PURE__*/React.createElement("div", {
        className: "form-container"
      }, submitting ? /*#__PURE__*/React.createElement("div", {
        style: {
          height: '100%'
        },
        className: "is_sending"
      }, /*#__PURE__*/React.createElement("p", {
        style: {
          position: 'absolute'
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: "loading-spinner"
      }))) : null, this.state.submitResult != null && this.state.submitResult.success == false ? /*#__PURE__*/React.createElement("div", {
        className: "form-row",
        style: {
          marginBottom: '1.8em',
          color: 'red',
          fontWeight: '500'
        }
      }, translate(this.state.submitResult.errorMessage)) : null, /*#__PURE__*/React.createElement("form", {
        onSubmit: handleSubmit(this.submit),
        className: "form form-component"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Field, {
        component: Radio,
        name: "entireDay",
        optionValue: "yes",
        label: translate('Entire day'),
        validate: this.validatePeriod,
        onChange: this.onEntireDay
      })), /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '.35rem'
        }
      }, /*#__PURE__*/React.createElement(Field, {
        component: Radio,
        name: "entireDay",
        optionValue: "no",
        label: translate('Part of day'),
        validate: this.validatePeriod,
        onChange: this.onPartOfDay
      }))), /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement(DatePickerFromTo, {
        timePicker: this.props.entireDay == 'no',
        onChange: this.onTimeChange,
        minDate: Moment(),
        type: "plan" // To have values.timeStart and values.timeEnd
        ,
        values: this.state,
        disabled: disableEditing,
        onValidate: this.onDatesValidate
      }), datesInvalid ? /*#__PURE__*/React.createElement("span", {
        style: {
          color: 'red'
        }
      }, translate('Dates must be today or in the future')) : null), /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      }), /*#__PURE__*/React.createElement("div", {
        className: "form-divider"
      }), /*#__PURE__*/React.createElement("div", {
        className: "form-row spacing submit"
      }, /*#__PURE__*/React.createElement(Button, {
        disabled: submitting || !valid || disableEditing || datesInvalid
      }, this.state.id != null ? translate('Save') : translate('Report')), /*#__PURE__*/React.createElement("div", {
        className: "align-right"
      }, this.props.absence != null ? /*#__PURE__*/React.createElement(Button, {
        onClick: this.onDelete,
        disabled: submitting || disableEditing,
        type: "secondary"
      }, translate('Remove')) : null, /*#__PURE__*/React.createElement(Button, {
        onClick: this.onCancel,
        disabled: submitting,
        type: "secondary"
      }, translate('Cancel'))))));
    }
  }]);
}(Component);
var FORM_NAME = 'ReportAbsence';
var getFormValue = formValueSelector(FORM_NAME);
function mapStateToProps(state) {
  return {
    submitResult: state.absence.submitResult,
    absences: state.absence.user,
    translate: translate(state.Languages.translations),
    entireDay: getFormValue(state, 'entireDay')
  };
}
export default connect(mapStateToProps, {
  deleteAbsence: deleteAbsence,
  addError: addError
})(reduxForm({
  form: FORM_NAME,
  destroyOnUnmount: true
})(ReportAbsenceForm));